<template>
  <div class="empty-state">
    <i v-if="icon" :class="icon" class="empty-state-icon" />
    <h4 class="empty-state-title">{{ title }}</h4>
    <p class="empty-state-message">{{ message }}</p>
    <base-button
      v-if="ctaLabel"
      type="secondary"
      class="empty-state-cta"
      @click="$emit('cta-click')"
    >
      {{ ctaLabel }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: 'Nada para exibir',
    },
    message: {
      type: String,
      default: 'Tente ajustar os filtros ou recarregar a página.',
    },
    icon: {
      type: String,
      default: 'fas fa-inbox',
    },
    ctaLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.empty-state {
  text-align: center;
  padding: var(--spacing-xl);
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-lg);
  background: var(--bg-elevated);
  color: var(--text-secondary);
}

.empty-state-icon {
  font-size: 1.75rem;
  color: var(--color-primary);
  margin-bottom: var(--spacing-sm);
}

.empty-state-title {
  margin-bottom: var(--spacing-xs);
  color: var(--text-primary);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.empty-state-message {
  margin: 0;
  color: var(--text-muted);
}

.empty-state-cta {
  margin-top: var(--spacing-md);
}
</style>
